<template>
  <div class="audioplayer">
    <div class="player-content">
      <div class="icon" @click="togglePlayer">
        <i :class="[paused ? 'icon-bofang1' : 'icon-zanting1', 'iconfont']"></i>
      </div>
      <div class="current-time">{{ currentTimeStr }}</div>
      <div class="status-bar" @click="changePregress">
        <div class="btm-status" ref="totalProgress"></div>
        <div class="current-status" :style="{ width: statusBarWidth }"></div>
      </div>
      <div class="total-time">{{ totalTimeStr }}</div>
    </div>
    <audio
      class="audioTag"
      :src="src"
      ref="audio"
      :currentTime="currentTime"
      @timeupdate="timeupdate"
      @canplaythrough="loadAudio"
      @pause="paused = true"
      @play="paused = false"
    ></audio>
  </div>
</template>

<script>
function formatMMSS(seconds) {
  seconds = Math.floor(seconds);
  let m = Math.floor(seconds / 60);
  let s = seconds % 60;
  return (m >= 10 ? m : "0" + m) + ":" + (s >= 10 ? s : "0" + s);
}
export default {
  name: "AudioComponent",
  data() {
    return {
      currentTimeStr: "00:00",
      totalTimeStr: "00:00",
      totalTime: 0,
      statusBarWidth: 0,
      paused: true,
      currentTime: 0,
    };
  },
  props: {
    // 音频的src
    src: {
      type: String,
      default: "",
    },
  },
  mounted() {},
  methods: {
    togglePlayer() {
      this.pauseAllPlayer();
      this.$refs.audio.paused
        ? this.$refs.audio.play()
        : this.$refs.audio.pause();
      this.paused = this.$refs.audio.paused;
    },
    pauseAllPlayer() {
      let audios = document.getElementsByTagName("audio");
      function pauseAll() {
        let self = this;
        [].forEach.call(audios, function (i) {
          // 将audios中其他的audio全部暂停
          i !== self && i.pause();
        });
      }
      // 给play事件绑定暂停函数
      [].forEach.call(audios, function (i) {
        i.addEventListener("play", pauseAll.bind(i));
      });
      this.paused = true;
    },
    timeupdate(e) {
      this.statusBarWidth =
        ((e.target.currentTime * 1000) / (this.totalTime * 1000)) * 100 + "%";
      this.currentTime = e.target.currentTime;
    },
    loadAudio(e) {
      this.totalTime = e.target.duration;
      // console.log(e.target.duration)
      this.totalTimeStr = formatMMSS(e.target.duration);
    },
    changePregress(e) {
      let event = e;
      this.$refs.audio.pause();
      let leftVal = event.offsetX - this.$refs.totalProgress.offsetLeft;
      this.statusBarWidth =
        (leftVal / this.$refs.totalProgress.offsetWidth) * 100 + "%";
      this.currentTime =
        (leftVal / this.$refs.totalProgress.offsetWidth) * this.totalTime;
      this.$refs.audio.currentTime = this.currentTime;
      this.$refs.audio.play();
    },
  },
  watch: {
    currentTime(newVal) {
      this.currentTimeStr = formatMMSS(newVal);
    },
  },
};
</script>
<style lang="scss" scoped>
.audioplayer {
  width: 280px;
  .player-content {
    width: 280px;
    height: 36px;
    background: #ffffff;
    border: 1px solid #e3e3e9;
    border-radius: 18px;
    display: flex;
    user-select: none;

    .icon {
      margin-left: 7px;
      width: 24px;
      border-radius: 50%;
      position: relative;

      i {
        font-size: 24px;
        line-height: 36px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        text-align: center;
      }
    }

    .current-time {
      margin-left: 10px;
      font-size: 14px;
      color: #444444;
      line-height: 36px;
    }

    .status-bar {
      flex: 1;
      margin-left: 3px;
      position: relative;
      cursor: pointer;

      .btm-status {
        width: 100%;
        height: 4px;
        background: #cbcbd1;
        border-radius: 2px;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }

      .current-status {
        width: 50%;
        height: 4px;
        background: #444444;
        border-radius: 18px 0 0 18px;
        position: absolute;
        left: 0;
        top: 50%;
        z-index: 1;
        transform: translateY(-50%);
      }
    }

    .total-time {
      margin-left: 10px;
      margin-right: 12px;
      font-size: 14px;
      color: #444444;
      line-height: 36px;
    }

    .audioTag {
      width: 0;
      height: 0;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
    }
  }

  .player-tip {
    font-size: 12px;
    color: #969696;
    line-height: 20px;
    font-weight: 400;
    margin-top: 10px;
    text-align: left;
  }
}
</style>
